export const INVITATION_EMAIL_PRESETS = {
  warm: {
    label: 'Warm',
    subject: 'You’re invited: {celebration_title}',
    intro: 'We’re excited to invite you to {celebration_title}. Open your invitation below to see the details and RSVP.',
    ctaLabel: 'Open Invitation',
    footer: 'We can’t wait to celebrate together.',
  },
  formal: {
    label: 'Formal',
    subject: 'Invitation to {celebration_title}',
    intro: 'You are warmly invited to join us for {celebration_title}. Please use the secure RSVP link below to review the details and respond at your convenience.',
    ctaLabel: 'View Invitation',
    footer: 'We look forward to celebrating with you.',
  },
  minimal: {
    label: 'Minimal',
    subject: 'RSVP for {celebration_title}',
    intro: 'You’re invited to {celebration_title}. Open your invitation below to view the details and RSVP.',
    ctaLabel: 'RSVP Now',
    footer: 'Thank you for celebrating with us.',
  },
} as const;
